import { useState } from "react";
import "./AboutMe.scss";
import AznivKolyan from "../../assets/images/AznivKolyan.jpg";
import MeriMelkonyan from "../../assets/images/MeriMelkonyan.jpg";

const team = [
  {
    name: "Azniv Kolyan",
    image: AznivKolyan,
    role: "Founder",
    text: `Founder of Electrolysis by AK, INC. She is licensed with ${new Date().getFullYear() - 2009} years of experience. Making people feel good in their skin was always a passion, and now is also her career. A career that stemmed out of her home country Armenia, and continues to this day in Los Angeles. Her studies in the field have helped hone her skills, and have helped her become one of the leaders in the industry.`,
  },
  {
    name: "Meri Melkonyan",
    role: "Electrologist",
    image: MeriMelkonyan,
    text: `A dedicated practitioner with over three years of experience in the field of permanent hair removal. Passionate about helping people feel confident in their own skin, Meri has turned her enthusiasm into a career that she truly loves. Just like her colleague Azniv, Meri is committed to bringing her expertise to each client she works with, ensuring they receive the best care and results. Her journey is all about combining skill with a genuine joy for helping others look and feel their best.`,
  },
];

const AboutMe = () => {
  const [index, setIndex] = useState(0);
  const member = team[index];

  return (
    <section className="aboutMe">
      <h1>About us</h1>

      {/* Role-based tabs */}
      <div className="teamTabs">
        {team.map((m, i) => (
          <button
            key={m.role}
            className={`tab ${i === index ? "active" : ""}`}
            onClick={() => setIndex(i)}
          >
            {m.role}
          </button>
        ))}
      </div>

      <div className="imgContainer">
        <img src={member.image} alt={member.name} />
      </div>

      {/* Name under image */}
      <h2 className="name">{member.name}</h2>

      <p className="text">{member.text}</p>
    </section>
  );
};

export default AboutMe;
